import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { AyudasService } from './ayudas.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AyudasEntry } from 'src/app/shared/entrys/ayudas.entry';
import { ModalAyudaComponent } from 'src/app/components/core/layouts/modal-ayudas/modal-ayuda.component';


@Component({
	selector: 'app-ayudas',
	templateUrl: './ayudas.component.html',
	styleUrls: ['./ayudas.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AyudasComponent implements OnInit {

	@Input()
	ayuda: AyudasEntry;

	@Input()
	class: string;

	constructor(private ayudasService: AyudasService, private modalService: NgbModal) { }

	ngOnInit() {

	}

	onAyuda() {
		this.ayudasService.get(this.ayuda).subscribe(resultado => {
			if (resultado.result) {
				const modalRef = this.modalService.open(ModalAyudaComponent,
					{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
				modalRef.componentInstance.notificacion = { contenido_mensaje: resultado.data.texto_ayuda };
			}
		});
	}
}
